import { logEvent } from "@/services/analytic";

export default {
  methods: {
    logEvent
  }
};
